// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".default-button{background-color:#e2001a;border:none;border-radius:4px;color:#fff;font-size:1.125rem;width:100%}.default-button:hover{background-color:#c90017;transition-duration:.3s}.default-button.disabled{background-color:#adadad;cursor:not-allowed}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
